import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  usePagination,
  Radio,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useEffect, useMemo } from "react";
import { styled } from "@mui/material/styles";
import cssVariables from "../../../../theme/cssVariables";
import { ReactComponent as GuideActiveIcon } from "../../../../icons/goal-guide-active.svg";
import { ReactComponent as GuideInActiveIcon } from "../../../../icons/goal-guide-inactive.svg";
import { ReactComponent as LibraryActiveIcon } from "../../../../icons/goal-library-active-2.svg";
import { ReactComponent as LibraryInActiveIcon } from "../../../../icons/goal-library-inactive-2.svg";
import { ReactComponent as BackIcon } from "../../../../icons/arrow-left.svg";

const CreateCorporateGoal = (props) => {
  const { t } = useTranslation();
  const [selectLibrary, setLibrary] = React.useState(1);
  const { state } = useLocation();
  const _ = require("lodash");
  const navigate = useNavigate();
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  const chooseLibrary = (val) => {
    setLibrary(val)
  }
  const goto = (path, data) => {
    navigate("/admin"+path, { replace: false, state: data });
  }
  const gotoCreateForm = () => {
    if (selectLibrary === 1) {
      goto(`/manage-corporate-goal/create/${selectLibrary}`, { cycleSerial: state?.cycleSerial ?? "", category: state?.category ?? "" })
    }else if (selectLibrary === 2) {
      goto(`/manage-corporate-goal/create-from-library`, { cycleSerial: state?.cycleSerial ?? "", category: state?.category ?? ""})
    }
  }
  return (
    <>
      <Helmet>
        <title>Choose Corporate Goal Library | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => navigate("/kpi/home")}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('/manage-corporate-goal')}>
                {` ${t('corporateGoal.label.title')}`}
              </span> /
              <span style={styles.end} >
                {` ${t('corporateGoal.label.create')}`}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container textAlign="center">
            <Grid item md={12} >
              <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500">
                {t('corporateGoal.label.titleCreateGoal')}
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16}>
                {t('corporateGoal.label.createGoalSub')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={6}>
            <Grid lg={6} xs={12} item>
              <Card style={{cursor: 'pointer', height: "100%"}} sx={{ mx: 5 }} onClick={() => {chooseLibrary(1)}}>
                <CardContent>
                  <Grid item lg={12} xs={12} container textAlign="center">
                    <Grid item>
                      <Radio name="radio" value="1" checked={selectLibrary === 1} size="small" />
                    </Grid>
                    <Grid item lg={12}>
                      {selectLibrary === 1 ? <img src={require('../../../../icons/goal-guide-active.svg').default} alt="Goal Guide - Active" height="161px"/> : <img src={require('../../../../icons/goal-guide-inactive.svg').default} alt="Goal Guide - Inactive" height="161px"/>}
                    </Grid>
                    <Grid item lg={12} mt={3}>
                      <Typography fontSize={24} lineHeight="21px" fontWeight="600">
                        {t('corporateGoal.label.goalGuide')}
                      </Typography>
                    </Grid>
                    <Grid item lg={12} mt={2} mb={2}>
                      <Typography fontSize={14} fontWeight="300" color="#939393">
                        {t('corporateGoal.label.goalGuideSub')}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid lg={6} xs={12} container item>
              <Card style={{cursor: 'pointer', height: "100%"}} sx={{ mx: 5 }} onClick={() => {chooseLibrary(2)}}>
                <CardContent>
                  <Grid item lg={12} xs={12} container textAlign="center">
                    <Grid item>
                      <Radio name="radio" value="2" checked={selectLibrary === 2} size="small" />
                    </Grid>
                    <Grid item lg={12}>
                      {selectLibrary === 2 ? <img src={require('../../../../icons/goal-library-active.svg').default} alt="Goal Library - Active" height="161px"/> : <img src={require('../../../../icons/goal-library-inactive.svg').default} alt="Goal Library - Inactive" height="161px"/>}
                    </Grid>
                    <Grid item lg={12} mt={3}>
                      <Typography fontSize={24} lineHeight="21px" fontWeight="600">
                        {t('corporateGoal.label.goalLibrary')}
                      </Typography>
                    </Grid>
                    <Grid item lg={12} mt={2}>
                      <Typography fontSize={14} fontWeight="300" color="#939393">
                        {t('corporateGoal.label.goalLibrarySub')}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid container direction="row" mt={4} item>
              <Grid container lg={1} xs={1} direction="row" style={{alignItems: 'center', cursor: 'pointer'}} onClick={() => goto('/manage-corporate-goal')}>
                <Grid item display="flex" alignItems="center">
                  <BackIcon/>
                  <Typography sx={{ ml: 1 }}>
                    { t("label.back") }
                  </Typography>
                </Grid>
              </Grid>
              <Grid lg={10} xs={12} container display="flex" alignItems="center" justifyContent="center">
                <Grid item>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => {gotoCreateForm()}}
                    color="primary"
                    variant="contained"
                    style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none' }}
                  >
                    <Typography>{t("label.next")}</Typography>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default CreateCorporateGoal;
